// Section clicks + views -> GTM "GA4event" pass-through; clicks also tag Clarity. Sitewide.
(function () {
  if (window.Shopify && Shopify.designMode) return;
  const template = (document.currentScript && document.currentScript.dataset.template) || 'page';
  const theme = window.Shopify && Shopify.theme;
  const live = !!(theme && theme.role === 'main');
  const main = document.getElementById('MainContent');

  // Readable names: "Collection: Sleepwear / 04 Product grid", "Home / Header topbar"
  const readable = (s) =>
    s.replace(/[-_]+/g, ' ').trim().replace(/[a-z]/i, (c) => c.toUpperCase()).replace(/\b(nfl|nba|mlb|nhl|ncaa)\b/gi, (w) => w.toUpperCase());
  const [type, suffix] = template.split('.');
  const [base, sub] = type.split('/');
  const pageName = { index: 'Home', 'list-collections': 'All collections', customers: 'Account' }[base] || readable(base);
  const detail = suffix || (sub !== 'account' && sub);
  const templateName = detail ? `${pageName}: ${readable(detail)}` : pageName;

  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  // Clarity only hears from the published theme; previews just log, like the GA4 payloads
  const toClarity = (...args) => (live ? clarity(...args) : console.debug('[section-tracking]', 'clarity', ...args));
  const themeName = theme && theme.name ? theme.name.split('/').pop() : '';
  if (themeName) toClarity('set', 'theme', themeName);
  toClarity('set', 'page_type', pageName);
  toClarity('set', 'template', templateName);

  const clean = (s) => (s || '').replace(/\u2060/g, '').replace(/\s+/g, ' ').trim().slice(0, 80);
  const siteName = (document.querySelector('meta[property="og:site_name"]') || {}).content;
  // Visible text, else aria-label (unless it's just the site name), else image alt
  const linkText = (el) => {
    const aria = clean(el.getAttribute('aria-label'));
    const img = el.querySelector && el.querySelector('img[alt]');
    return clean(el.innerText) || (aria !== siteName && aria) || clean(img && img.alt);
  };
  const campaignLabel = (banner) => `Campaign banner: ${clean(banner.dataset.campaignName) || 'unnamed'}`;

  const area = (section) => {
    if (main && section.parentElement === main) {
      const position = [...main.children].filter((c) => c.classList.contains('shopify-section')).indexOf(section) + 1;
      return String(position).padStart(2, '0');
    }
    const group = section.className.match(/shopify-section-group-([\w-]+?)-group/);
    return group ? group[1] : 'other';
  };
  const parts = (section) => {
    const where = area(section);
    // Drops the editor's random 6-char code (hand-named ffsale, slider stay) and a repeated group name
    const what = section.id
      .split('__')
      .pop()
      .replace(/_(?!ffsale$|slider$)[A-Za-z0-9]{6}$/, '')
      .replace(new RegExp(`^${where}(?:[-_]|$)`), '')
      .replace(/^breadcrumbs_\w+$/, 'breadcrumbs');
    return [where, what];
  };
  const cardsOf = (section) => {
    const [where, what] = parts(section);
    if (what.startsWith('grid_banner')) return [...section.querySelectorAll('.grid-banner__item')];
    if (where === 'footer' && what.startsWith('multicolumn')) return [...section.querySelectorAll('.multicolumn-card')];
    if (what.startsWith('buttons_with_icon')) return [...section.querySelectorAll('.button-list__item')];
    return [];
  };
  // Cards tracked one by one: homepage grid banners and buttons (shop by child), and the footer multicolumn (a one-card swiper on phones)
  const trackedCards = (section) =>
    (pageName === 'Home' && main && section.parentElement === main) || area(section) === 'footer' ? cardsOf(section) : [];
  // Tracking name picked in the editor (snippets/tracking-name.liquid), else a grid banner names itself by card count
  const nameOf = (section) => {
    const marker = section.querySelector('template[data-tracking-name]');
    if (marker && clean(marker.dataset.trackingName)) return clean(marker.dataset.trackingName);
    const cards = parts(section)[1].startsWith('buttons_with_icon') ? 0 : cardsOf(section).length;
    return cards ? `${cards}_column` : '';
  };
  // Header and footer names keep their group ("Home / Footer 3_column") so they never share a row with page sections
  const categoryOf = (section) => {
    const name = nameOf(section);
    const [where, what] = parts(section);
    if (name) return /^\d+$/.test(where) ? `${templateName} / ${name}` : `${templateName} / ${readable(where)} ${name}`;
    return `${templateName} / ${readable(`${where} ${what}`)}`;
  };
  // Hero: the first image at least 60% of the page's width, homepage and landing pages only
  let hero;
  const heroOf = () => {
    if (hero !== undefined) return hero;
    hero = null;
    if (!main || (pageName !== 'Home' && base !== 'page')) return hero;
    const wide = main.getBoundingClientRect().width * 0.6;
    const units = [...main.children].filter((c) => c.classList.contains('shopify-section')).flatMap((s) => (trackedCards(s).length ? trackedCards(s) : [s]));
    hero = units.find((u) => [...u.querySelectorAll('img')].some((img) => img.getBoundingClientRect().width >= wide)) || null;
    return hero;
  };
  // Section position: "4", "4-2" or "footer-2" for a tracked card, "header"/"footer" for groups, plus " hero". No leading 0: GA4 stores a bare "04" as 4
  const positionOf = (section, card) => {
    const where = area(section).replace(/^0+(?=\d)/, '');
    const cards = card ? trackedCards(section) : [];
    const position = cards.includes(card) ? `${where}-${cards.indexOf(card) + 1}` : where;
    const first = heroOf();
    return first && (first === section || first === card) ? `${position} hero` : position;
  };
  // Link numbers only where position is the lesson: homepage sections and the sub-category slider
  const numbered = (section) => {
    const [where, what] = parts(section);
    return (pageName === 'Home' && /^\d+$/.test(where)) || what === 'collection_list_slider';
  };
  const pathOf = (href) => {
    if (!href) return '';
    const url = new URL(href, location.origin);
    if (url.origin === location.origin && url.pathname === '/cart/change') return '/cart/change'; // line ids are unique per cart
    [...url.searchParams.keys()].filter((k) => /^(pr_|_)/.test(k)).forEach((k) => url.searchParams.delete(k)); // Shopify rec/search tracking params
    return url.origin === location.origin ? url.pathname + url.search : url.href;
  };
  // A view carries the link when everything in it goes to one place
  const linkOf = (el) => {
    const paths = [...new Set([...el.querySelectorAll('a[href]')].map((a) => pathOf(a.getAttribute('href'))))];
    return paths.length === 1 ? paths[0] : '';
  };
  // Submits that leave the page count as navigation: checkout and GET forms (search). Add to cart and other POSTs stay interactions
  const submitTo = (el) => {
    if (!el.form || el.type !== 'submit') return '';
    if (el.name === 'checkout') return '/checkout';
    return (el.form.getAttribute('method') || 'get').toLowerCase() === 'get' ? el.form.getAttribute('action') || '' : '';
  };
  // Clarity funnel steps, a short stable list: homepage sections, header, collection sub-category slider
  const stepOf = (section) => {
    const [where, what] = parts(section);
    if (pageName === 'Home' && /^\d+$/.test(where)) return nameOf(section) ? `Home ${nameOf(section)}` : `Home section ${where}`;
    if (where === 'header') return readable(`${where} ${what}`);
    if (pageName === 'Collection' && what === 'collection_list_slider') return 'Collection slider';
    return '';
  };

  const send = (name, category, label, url, position) => {
    const payload = {
      event: 'GA4event',
      'ga4-event-name': name,
      'ga4-event-p1-name': 'event_category',
      'ga4-event-p1-value': category,
      'ga4-event-p2-name': 'event_label',
      'ga4-event-p2-value': label,
      'ga4-event-p3-name': 'link_url',
      'ga4-event-p3-value': url,
      'ga4-event-p4-name': 'theme',
      'ga4-event-p4-value': themeName,
      'ga4-event-p5-name': 'section_position',
      'ga4-event-p5-value': position || '',
    };
    if (live) (window.dataLayer = window.dataLayer || []).push(payload);
    else console.debug('[section-tracking]', payload);
  };

  document.addEventListener(
    'click',
    (e) => {
      const el = e.target.closest && e.target.closest('a[href], button, [role="button"]');
      if (!el) return;
      const section = el.closest('.shopify-section');
      if (!section) return;

      const category = categoryOf(section);
      const banner = el.closest('.bloomreach-campaign-banner');
      const card = el.closest('.grid-banner__item, .multicolumn-card, .button-list__item');
      const href = el.getAttribute('href') || '';
      const path = pathOf(href || submitTo(el));
      // section_click is navigation only; slider arrows, add to cart and quantity go as section_interact
      const nav = !!(href || path);

      if (nav) {
        toClarity('event', 'section_click');
        toClarity('set', 'section_click', category);
      }
      const step = banner ? 'Campaign banner' : stepOf(section);
      if (step) toClarity('event', `Click: ${step}`);
      // Cart links carry the item count ("Cart3"); drop it
      const text = banner ? campaignLabel(banner) : path === '/cart' ? clean(linkText(el).replace(/\d+/g, ' ')) : linkText(el);
      // Numbered by the reported path, so "?_pos=1" and "?_pos=2" on one product share a number
      const paths = [...new Set([...section.querySelectorAll('a[href]')].map((a) => pathOf(a.getAttribute('href'))))];
      const label = numbered(section) ? `${href ? paths.indexOf(path) + 1 : '-'} ${text}` : text;
      send(nav ? 'section_click' : 'section_interact', category, label, path, positionOf(section, card));
    },
    true
  );

  // Views: main + footer sections, homepage grid banner and footer cards, and Bloomreach campaign banners, once per page, after 1s at half visible (or half the screen).
  const heading = (section) => {
    const h = section.querySelector('h1, h2, h3, .card-media__heading');
    // Hyper's fade-up keeps the heading hidden until it animates in, and hidden text has no innerText
    return h ? clean(h.innerText) || clean(h.textContent) : '';
  };
  const viewOf = (target) => {
    const section = target.classList.contains('shopify-section') ? target : target.closest('.shopify-section');
    if (target.classList.contains('bloomreach-campaign-banner')) send('section_view', categoryOf(section), campaignLabel(target), '', positionOf(section));
    else {
      // A card with no heading (shop by child buttons) is labeled by its link text, or its own text when it has no single link
      const card = target === section ? null : target;
      const link = card && linkOf(card) && card.querySelector('a[href]');
      send('section_view', categoryOf(section), heading(target) || (card ? linkText(link || card) : ''), linkOf(target), positionOf(section, card));
    }
  };
  const timers = new Map();
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const section = entry.target;
        const seen =
          entry.isIntersecting &&
          entry.boundingClientRect.height > 0 &&
          (entry.intersectionRatio >= 0.5 || entry.intersectionRect.height >= window.innerHeight / 2);
        if (seen && !timers.has(section)) {
          timers.set(
            section,
            setTimeout(() => {
              io.unobserve(section);
              viewOf(section);
            }, 1000)
          );
        } else if (!seen && timers.has(section)) {
          clearTimeout(timers.get(section));
          timers.delete(section);
        }
      });
    },
    { threshold: Array.from({ length: 21 }, (_, i) => i / 20) }
  );
  document.querySelectorAll('.shopify-section').forEach((s) => {
    if ((main && s.parentElement === main) || s.classList.contains('shopify-section-group-footer-group')) {
      (trackedCards(s).length ? trackedCards(s) : [s]).forEach((t) => io.observe(t));
    }
  });
  document.querySelectorAll('.bloomreach-campaign-banner').forEach((b) => b.closest('.shopify-section') && io.observe(b));

  // Drawers and modals (cart, Quick View, mobile menu, popups): every open counts.
  const isModal = (el) =>
    typeof ModalComponent !== 'undefined' ? el instanceof ModalComponent : /-(drawer|modal)$/.test(el.localName);
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      const el = m.target;
      if (m.oldValue !== null || !el.hasAttribute('open') || !isModal(el)) return;
      const section = el.closest('.shopify-section');
      send('section_view', section ? categoryOf(section) : `${templateName} / ${readable(`overlay ${el.id || el.localName}`)}`, 'open', '', section ? positionOf(section) : 'overlay');
    });
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'], attributeOldValue: true });
})();
